/**
 * 故障详单
 */
import React, {useEffect, useRef, useState} from 'react'
import moment from 'moment';
import {DatePicker, Spin, Typography ,Select} from 'antd';
const {Link } = Typography;
const { RangePicker } = DatePicker;
import 'moment/locale/zh-cn';
import {AuthButton, ExportFile, StatisticsDate,SimpleTreeUpdate,DeviceSearch,WWTable} from "@/globalComponents";
import {WWMethods, WWUtils,wwConstants,} from "@/tools";
moment.locale('zh-cn');
export default function ForkliftStatisticsDetail(props) {
    const [dates, setDates] = useState([moment().subtract(1, 'day'),moment().subtract(1, 'day')]);
    const [organizationId,setOrganizationId] =useState(props.organizationId ? props.organizationId: localStorage.getItem("organizationId"));
    const [organizationName,setOrganizationName] = useState(localStorage.getItem("organizationName"))
    const [value, setValue] = useState([]);
    const [pageSize,setPageSize] = useState(10);
    const [currentPage,setCurrentPage] = useState(1);
    const [carId, setCarId] = useState('');
    const [beanList, setBeanList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [winH,setWinH] = useState(window.innerHeight)
    const [winW,setWinW] = useState(window.innerWidth)
    const [count,setCount] = useState(0)
    const [faultTypes,setFaultTypes] = useState([])
    const [alarmTypes,setAlarmTypes] = useState([])
    const [choosedValue,setChoosedValue] = useState( "yestaday");
    const [optionsArr,setOptionsArr] = useState(WWUtils.getOptionsFromGlobalEnums("enums.forkliftFaultCode.eMotorAlarm", "").concat(WWUtils.getOptionsFromGlobalEnums("enums.forkliftFaultCode.batteryAlarm", "")))
    const dateRef = useRef(null);
    const deviceRef = useRef(null);
    const isInitialMount = useRef(true);
    const forkLift_detail_tree_Ref = useRef(null);
    const isGoogle = localStorage.getItem('isGoogleMap');
    const isGoogleSatellite = localStorage.getItem('isGoogleSatelliteMap');

    useEffect(() => {
        // 页面变化时获取浏览器窗口的大小
        window.addEventListener('resize',onWindowResize);
        return()=>{
            // 组件销毁时移除监听事件
            window.removeEventListener('resize',onWindowResize);
        }
    }, []);

    useEffect(()=>{
        forkLift_detail_tree_Ref.current.updateDatas_simple({
            treeVisible:false,
            popVisible:false,
            showSelect:true,
            expandKeys:[localStorage.getItem("organizationId").toString()],
            organizationName:Strings.selectorg || "请选择门店",
            selectedKeys:[localStorage.getItem("organizationId").toString()],
            organizationId:"",
            showRootName:false,
            isTallTree:true
        });
    },[])
    useEffect(() => {
        //控制在组件挂载时不触发getCount
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            getCount();
        }
    }, [currentPage,pageSize]);

    useEffect(() => {
        let searchValue
        if(props.record){
            if (props.record.imei) {
                searchValue = props.record.carCode + " (IMEI:" + props.record.imei + ")";
            } else {
                searchValue = props.record.carCode
            }
            setCarId(props.record.carId);
        }else {
            searchValue = null;
            setCarId("")
        }
        setDates([props.startTime, props.endTime]);
        setOrganizationId(props.organizationId)
        deviceRef.current.resetSearchValue(searchValue);
        setChoosedValue(props.choosedValue);
        if (Array.isArray(props.alarmType)) {
            setFaultTypes(props.alarmType.code);
        } else {
            setFaultTypes([props.alarmType.code]);
        }
    }, [props]);

    //在页面跳转后获取即时地更新数据并查询相关报警信息
    useEffect(() => {
        getCount();
    }, [dates, alarmTypes]);

    useEffect(() => {
        setOptionsArr(faultOptions())
    }, [faultTypes]);
    //视窗变化
    const onWindowResize = ()=> {
        setWinH(window.innerHeight);
        setWinW(window.innerWidth)
    }
    //重置查询参数
    const resetParams = () => {
        setDates([moment().subtract(1, 'day'),moment().subtract(1, 'day')])
        setValue([]);
        setCarId('');
        setAlarmTypes([])
        setLoading(false)
        setOrganizationId("")
        dateRef.current.updateDatePickerTime({ target: { value: 'yestaday' } });
        deviceRef.current.resetSearchValue(null);
        forkLift_detail_tree_Ref.current.setState({organizationName:Strings.selectorg || "请选择门店"})
    }
    //不可选取时间
    const disabledDate = (current) => {
        return WWMethods.disabledDate(current,dates)
    };
    //时间按钮组件操作
    const changeTime = (startTime, endTime) => {
        setDates([startTime,endTime])
    };
    //日历控件操作

    const onOpenChange = (open) => {
        WWMethods.onOpenChange(open,()=>{
            setDates([null, null]);
        },()=>{
            setDates(null);
        })
    }
    function formatSearchParams() {
        let timeRange
        if(dates){
            timeRange = WWUtils.getTimeFromCalendar(dates);
        }else {
            timeRange = WWUtils.getTimeFromCalendar(value);
        }
        return {
            carId,
            faultTypes,
            faultCodes:alarmTypes,
            currentPage,
            pageSize,
            timeRange,
            orgId:organizationId
        }
    }
    const onShowSizeChange = (curPage, pSize)=>{
        setCurrentPage(curPage);
        setPageSize(pSize);
    }

    //获取count
    const getCount = ()=>{
        WWMethods.getForkliftStatisticsDetailCount(formatSearchParams(),(data)=> {
            setCount(data);
            getList();
        })
    }
    //获取列表数据
    const getList = ()=>{
        setLoading(true)
        WWMethods.getForkliftStatisticsDetailList(formatSearchParams(),(data)=> {
            setLoading(false)
            if(data.code === 0) {
                setBeanList(data.data);
            }
        })
    }
    const updateAddress = (lat,lng,mapType,index) =>{
        let temp_ms_list = Array.from(beanList);
        WWMethods.getAddressDetail(lat,lng,(address)=>{
            temp_ms_list[index].address = address;
            setBeanList(temp_ms_list);
        })
    }

    const handleDeviceChange = (carId) => {
        setCarId(carId)
    };

    const handleAccountChange = (id,name)=>{
        setOrganizationId(id);
        setOrganizationName(name)

    }

    const columns = [
        {
            title: Strings.orgName || "所属用户" ,
            dataIndex: 'orgName',
            width:'150px'
        },
        {
            title: Strings.carCode || "机械编号",
            dataIndex: 'carCode',
            width:'200px',
        },
        {
            title: Strings.imei || "设备号",
            dataIndex: 'imei',
            width:'180px',
        },{
            title: Strings.errorType || "故障类型",
            dataIndex: 'faultTypeDesc',
            width: '150px',
        },{
            title: Strings.errorinfo || "故障内容/代码",
            dataIndex: 'faultCodeDesc',
            width:'200px',
        },{
            title: Strings.errortime || "故障时间",
            dataIndex: 'faultTime',
            width:'180px',
            render:(text,record)=>{
                return WWUtils.formatTimeYMDHms(text);
            }
        },{
            title: Strings["common.gpsTime"] || "定位时间",
            dataIndex: 'gpsTime',
            width:'180px',
            render:(text,record)=>{
                return WWUtils.formatTimeYMDHms(text);
            }
        },{
            title: localStorage.getItem('speed') === "mp/h" ? Strings.rs10524 : Strings.rs10168,
            dataIndex: 'speed',
            width:'180px',render: function (text, col, index) {
                let speed = text
                if (speed && localStorage.getItem('speed') === "mp/h") {
                    speed = parseFloat(speed) / 1.609
                    speed = parseFloat(speed).toFixed(2)
                }
                return <sapn>{speed}</sapn>
            }
        },
        {
            title: Strings.address|| "位置",
            dataIndex: "address",
            width: "200px",
            render: function (text, record,index) {
                let mapType = 1;
                if (isGoogle === '1' || isGoogleSatellite === '1') {
                    mapType=0
                }
                return (
                    text?text: (record.lng &&  record.lat)? <a onClick={()=>{
                        updateAddress(record.lat,record.lng,mapType,index)
                    }}>{Strings.getAddress || "获取位置"}</a> : <span></span>
                )
            },
        }
    ];

    const faultOptions = ()=>{
        let options_arr = []
        if(faultTypes && (faultTypes.length === 0 || faultTypes.length === 2)){//两种故障类型都有或者默认清空下
            options_arr =  WWUtils.getOptionsFromGlobalEnums("enums.forkliftFaultCode.eMotorAlarm", "").concat(WWUtils.getOptionsFromGlobalEnums("enums.forkliftFaultCode.batteryAlarm", ""))
        }else{
            if(faultTypes && faultTypes.includes("5002")){
                options_arr=  WWUtils.getOptionsFromGlobalEnums("enums.forkliftFaultCode.batteryAlarm", "")
            }else{
                options_arr = WWUtils.getOptionsFromGlobalEnums("enums.forkliftFaultCode.eMotorAlarm", "")
            }
        }
        // console.log(options_arr)
        return options_arr;
    }
    return (
        <Spin spinning={loading}>
            <div id={"alarmdetail_search"} className={"searchWrapper mgb15"}>
                <div className={"firstRow searchRow alt"}>
                    <div className={"searchDiv"}>
                        <div className="searchItem">
                            <div className={"items"}>
                                <div className={"item"}>
                                    <label className={"labelfont"}>{Strings.orgName || "所属用户"}</label>
                                    <div className={`forklift_Detail_tree_wrapper tree_wrapper`} style={{display:"inline-block",position:"relative",marginLeft:7}}>
                                        <SimpleTreeUpdate ref={forkLift_detail_tree_Ref}
                                                          selectWidth={240}
                                                          margins={"5px auto"}
                                                          organizationId={organizationId}
                                                          parentClass={`forklift_Detail_tree_wrapper`}
                                                          directShowTree={false}
                                                          showRootName={false}
                                                          handleChange={handleAccountChange}
                                                          sendAccountId={handleAccountChange}
                                        />
                                    </div>
                                </div>
                                <div className={"item w240"}>
                                    <DeviceSearch ref={deviceRef} className={"mg15"} onChange={handleDeviceChange}/>
                                </div>
                                <div className={"item"}>
                                   <Select className={"w150 brr0"} placeholder={Strings.all || "全部"}
                                           showSearch ptionFilterProp="children" filterOption={(input, option) =>
                                       (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                   } mode={"multiple"} value={faultTypes}  onChange={(types)=>{
                                       setFaultTypes(types);
                                   }} allowClear={true} onClear={()=>setFaultTypes([])}
                                           options={WWUtils.getOptionsFromGlobalEnums("enums.forkliftFaultType", "select",true)}>
                                   </Select>
                                    <Select className={"w240 brl0"} placeholder={Strings.forkliftFaultCode || "请选择故障内容"}
                                            showSearch ptionFilterProp="children"  filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    } allowClear={true} onClear={()=>setAlarmTypes([])} mode={"multiple"} value={alarmTypes} onChange={setAlarmTypes} maxTagCount={"responsive"}
                                             options={optionsArr.map((item)=>{
                                                 return {value:item.code,label:item.name}
                                             })}>
                                    </Select>
                                </div>
                            </div>
                            <div className={"mgt15 item"}>
                                <StatisticsDate
                                    ref={dateRef}
                                    isShowToday={true}
                                    changeTime={changeTime}
                                    dateFormat={wwConstants.timeSet.dateFormatWithOutHMS}
                                    choosedValue={choosedValue}/>
                                <RangePicker
                                    value={dates || value}
                                    onCalendarChange={(val) => {
                                        setDates(val);
                                    }}
                                    format={wwConstants.timeSet.dateFormatWithOutHMS}
                                    onChange={(val) => {
                                        setValue(val);
                                    }}
                                    onOpenChange={onOpenChange}
                                    disabledDate={disabledDate}/>
                            </div>
                        </div>
                    </div>
                    <div className={"btnswrapper"}>
                        <AuthButton className={"mgl30 widauto"} type="primary" authKey={true} onClick={() => {
                            currentPage !== 1 ? setCurrentPage(1) : getCount()
                        }}>{Strings.search || "搜索"}</AuthButton>
                        <AuthButton className={"mgl10 mgt15 widauto"} type="reset" authKey={true} onClick={resetParams}>{Strings.reset || "重置"}</AuthButton>
                    </div>
                </div>
            </div>

            <div className="border_table">
                <div className={"bathOptsWrapper"}>
                    <div className={"leftopts"}></div>
                    <ExportFile params={formatSearchParams()} type={"forkliftFaultRecord"} ></ExportFile>
                </div>
                <WWTable className="new_app_table"
                         bordered={false}
                         columns={columns}
                         pagination={false}
                         dataSource={beanList}
                         innerHeight={winH-358}
                         width={winW-231}
                         pageSize={pageSize}
                         count={count}
                         currentPage={currentPage}
                         onChange={onShowSizeChange}
                         onShowSizeChange={(currentPage,pageSize)=>{
                             onShowSizeChange(1,pageSize)
                         }}/>
            </div>
        </Spin>
    )

}

